import React from "react";
import Layout from "../components/Layout";
import { ClientesBuenosMotos as ClientesBuenosMotosComponent } from "../components/ClientesBuenosMotos/ClientesBuenosMotos";

const ClientesBuenosMotos = () => {
    return (
        <>
            <Layout />
            <div>
                <ClientesBuenosMotosComponent />
            </div>
        </>
    );
};

export default ClientesBuenosMotos;
